import { Amplify } from 'aws-amplify';
import { config } from './config';

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    Amplify.configure(config);
    hasInitialized = true;
  }
})();
